<template>
  <div>
    <div class="bg-brand-primary header w-100 p-absolute top-0">
      <div class="d-flex w-50"></div>
    </div>
    <div class="container d-flex column gap-16 justify-center items-center" :class="{ 'gap-24': !linkData }">
      <div class="d-flex justify-center items-center z-100 merchant w-100 bg-brand-primary">
        <MerchantNavigator v-if="merchantData" :user="merchantData" @click="() => handleIsOpenUpdate(true)" class="w-100" />
      </div>
      <div v-if="linkData && linkData?.description !== ''" style="margin-top: 8px" class="form w-100 bg-cont-white d-flex column gap-8 z-100">
        <span class="form-merchant-title text-h20 text-bold leaning-28">
          {{ linkData?.merchant?.title }}
        </span>
        <div class="form-description leaning-24 text-b14">
          <ExpandableText v-if="!showMore" :text="linkData.description" :line-number="3" />
          <div v-else>
            {{ linkData.description }}
          </div>
        </div>

        <div v-if="linkData.description.length >= 120" class="d-flex items-center color-brand-primary text-b14 leaning-10 text-medium gap-4" @click="toggleShowTextHandler">
          <span>{{ toggleShowText }}</span>
          <span :class="showMoreClass" class="arrow">
            <Icons name="arrow-blue" />
          </span>
        </div>
      </div>
      <TheForm class="form bg-cont-white d-flex column gap-32 z-100 w-100" error-box :errorMessage="errorMessages" @submit="handleSubmit">
        <slot></slot>
        <template v-slot:footer>
          <Logo name="securePayment" />
        </template>
      </TheForm>
      <div class="footer-payment-container d-flex justify-center">
        <TheFooter />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MerchantNavigator from '@/components/merchant-navigator/index.vue';
import TheFooter from '@/components/the-footer/index.vue';
import TheForm from '@/components/the-form/index.vue';
import Icons from '@/components/base/icon/index.vue';
import ExpandableText from '@/components/expandable-text-card/index.vue';
import Logo from '@/components/logo/index.vue';
import { computed, inject, ref, type Ref } from 'vue';
import type { ZarinLink, PersonalLink } from '@/types';

const linkData = inject<Ref<ZarinLink | null>>('link-data');
const personalLinkData = inject<Ref<PersonalLink | null>>('personal-link-data');
const errorMessages = inject<string[]>('error-messages', []);
const handleSubmit = inject<() => void>('handle-form-submit', () => {});
const handleIsOpenUpdate = inject<(value: boolean) => void>('handle-open-modal', () => {});

const showMore = ref<boolean>(false);
const showMoreClass = computed(() => (showMore.value ? 'down' : 'up'));
const toggleShowText = computed(() => (showMore.value ? 'کمتر ' : 'بیشتر'));
const merchantData = computed(() => linkData?.value?.merchant || personalLinkData?.value?.merchant);

const toggleShowTextHandler = () => {
  showMore.value = !showMore.value;
};
</script>
<style scoped lang="scss">
@import url('./PaymentLayout.scss');
</style>
